import * as React from "react";

interface IShortCutKeyHandlerProps {
	shortcuts: { [key: string]: any };
}

export class ShortCutKeyHandler extends React.Component<IShortCutKeyHandlerProps, {}>
{
	onKeyUp = (event: KeyboardEvent) => {
		let handler = this.props.shortcuts[event.which];
		if (handler) {
			handler.call();
		}
	}
	componentDidMount() {
		document.addEventListener('keyup', this.onKeyUp);
	}
	componentWillUnmount() {
		document.removeEventListener('keyup', this.onKeyUp);
	}
	render(): JSX.Element {
		return null
	}
}